import {
  type ContentResource,
  type MessageTypeResource,
} from './api/resources/messages'
import {
  type CallContent,
  type ExternalReferenceContent,
  type MessageContent,
  type SystemContent,
  type TextContent,
  type UnknownContent,
} from './content'
import { type MessageType } from './message-type'

/**
 * Maps an API content type to our model message type.
 */
export function mapMessageTypeResourceToMessageType(
  messageType: MessageTypeResource,
): MessageType {
  switch (messageType) {
    case 'NOTE':
    case 'TEAM_NOTE':
    case 'ADMIN_NOTE':
      return 'Note'
    case 'ADMIN':
      return 'AdminMessage'
    case 'SYSTEM':
      return 'SystemMessage'
    case 'EXTERNAL_REFERENCE':
      return 'ExternalReference'
    default:
      return 'Message'
  }
}

/**
 * Maps API content to our model content.
 */
export function mapContentResourceToContent(
  resource: ContentResource,
): MessageContent {
  switch (resource.type) {
    case 'TEXT':
    case 'ADMIN':
      return {
        type: 'Text',
        text: resource.text,
      } satisfies TextContent
    case 'SYSTEM':
      return {
        type: 'System',
        text: resource.text,
      } satisfies SystemContent
    case 'CALL': {
      return {
        type: 'Call',
      } satisfies CallContent
    }
    case 'EXTERNAL_REFERENCE': {
      return {
        type: 'ExternalReference',
        externalType: resource.external_type,
        externalId: resource.external_id,
        text: resource.text,
      } satisfies ExternalReferenceContent
    }

    default:
      if ('text' in resource && typeof resource.text === 'string') {
        return { type: 'Text', text: resource.text }
      }

      return {
        type: 'Unknown',
      } satisfies UnknownContent
  }
}
